import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "tool-event-title" }

import { computed } from 'vue'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'
import type { ToolEvent } from '@/types/msq'
import {
  getEventTypeClass,
  getToolName,
  getTruncatedResponse
} from '@/utils/toolEvents'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolEventsPanel',
  props: {
    toolEvents: {},
    showActivity: { type: Boolean, default: false },
    compact: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const iconMargin = computed(() => props.compact ? 'mr-2' : 'mr-4')
const iconSize = computed(() => props.compact ? 'small' : undefined)

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.toolEvents && _ctx.toolEvents.length > 0)
      ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
          key: 0,
          density: "compact",
          class: _normalizeClass(['tool-events-container', _ctx.compact ? 'mb-2' : 'mb-4'])
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toolEvents, (event, eventIndex) => {
              return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                key: eventIndex,
                class: _normalizeClass(['event-panel', _unref(getEventTypeClass)(event.type)]),
                "bg-color": "background",
                elevation: "0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_expansion_panel_title, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        (event.type === 'tool_start')
                          ? (_openBlock(), _createBlock(_component_v_icon, {
                              key: 0,
                              color: "primary",
                              class: _normalizeClass(iconMargin.value),
                              size: iconSize.value
                            }, {
                              default: _withCtx(() => _cache[0] || (_cache[0] = [
                                _createTextVNode("mdi-wrench-clock")
                              ])),
                              _: 1,
                              __: [0]
                            }, 8, ["class", "size"]))
                          : (event.type === 'tool_end')
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                color: "secondary",
                                class: _normalizeClass(iconMargin.value),
                                size: iconSize.value
                              }, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                  _createTextVNode("mdi-check-outline")
                                ])),
                                _: 1,
                                __: [1]
                              }, 8, ["class", "size"]))
                            : (event.type === 'tool_warning')
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 2,
                                  color: "warning",
                                  class: _normalizeClass(iconMargin.value),
                                  size: iconSize.value
                                }, {
                                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                                    _createTextVNode("mdi-alert-outline")
                                  ])),
                                  _: 1,
                                  __: [2]
                                }, 8, ["class", "size"]))
                              : (event.type === 'llm_start')
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 3,
                                    color: "primary",
                                    class: _normalizeClass(iconMargin.value),
                                    size: iconSize.value
                                  }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                      _createTextVNode("mdi-timer-play-outline")
                                    ])),
                                    _: 1,
                                    __: [3]
                                  }, 8, ["class", "size"]))
                                : (_openBlock(), _createElementBlock("span", {
                                    key: 4,
                                    class: _normalizeClass(['event-badge', _unref(getEventTypeClass)(event.type), iconMargin.value])
                                  }, _toDisplayString(event.type), 3)),
                        _createElementVNode("span", {
                          class: _normalizeClass(['tool-name', { 'text-caption': _ctx.compact }])
                        }, _toDisplayString(_unref(getToolName)(event)), 3),
                        _createElementVNode("span", {
                          class: _normalizeClass(['tool-response', 'text-truncate', _unref(getEventTypeClass)(event.type), { 'text-caption': _ctx.compact }])
                        }, _toDisplayString(_unref(getTruncatedResponse)(event)), 3)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_expansion_panel_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VueJsonPretty), {
                        data: event.data,
                        deep: 4,
                        theme: "dark"
                      }, null, 8, ["data"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "tool-activity-fade" }, {
      default: _withCtx(() => [
        (_ctx.showActivity)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['tool-activity-banner', _ctx.compact ? 'mb-2' : 'mb-4'])
            }, [
              _createVNode(_component_v_icon, {
                size: "18",
                color: "primary",
                class: "mr-2"
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-database-search")
                ])),
                _: 1,
                __: [4]
              }),
              _createElementVNode("span", {
                class: _normalizeClass({ 'text-caption': _ctx.compact })
              }, "Gathering data...", 2)
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})